module.exports = __webpack_public_path__ + "img/4.53afb4b.svg";